import { Component, OnInit, LOCALE_ID, Inject } from '@angular/core';

import { StrapiService } from '@nx/strapi';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { lmwBaseRoutes } from '../../routing/route-locales/lmw-base-routes';
import { FooterCms } from '../../interfaces/footer-cms.interface';
import { environment } from 'apps/learn-my-way/src/environments/environment';

@Component({
  selector: 'lmw-base-footer-base',
  templateUrl: './footer-base.component.html'
})
export class FooterBaseComponent implements OnInit {

  public privacyPageLink:string = lmwBaseRoutes.privacyStatePath;
  public cookiesPageLink:string = lmwBaseRoutes.cookiesStatePath;
  public termsAndConditionsPageLink:string = lmwBaseRoutes.termsAndConditionsStatePath;
  public accessibilityPageLink:string = lmwBaseRoutes.accessibilityStatePath;
  public reportAnIssuePageLink:string = lmwBaseRoutes.reportAnIssueStatePath;
  public footerCms: Observable<FooterCms>;
  public loadCookies: boolean = environment.loadCookies;

  constructor(private strapiService: StrapiService, @Inject(LOCALE_ID) public locale: string) { }

  ngOnInit(): void {
    this.footerCms = this.strapiService.get('footer').pipe(publishReplay(1),refCount());
  }
}
